import React from 'react';

import cx from 'classnames';
import styles from './Style.module.scss';


class CardView extends React.Component {
  constructor(props){
    super(props);
  }

  render(){
    return (
      <div className={cx(styles.card, this.props.className)} onClick={this.props.onClick}>
        {this.props.children}
      </div>
    );
  }
}

export default CardView;